// const wiaFilterByProduct = {
//   bandWidth: [],
//   AccessTechnology: [],
//   dataLimitType: [],

import { FilterFormFieldStrategyType } from "@/common/types";

// };
const wiaFilterByProduct: FilterFormFieldStrategyType[] = [];
export default wiaFilterByProduct;
